import React, { useEffect, useState } from "react";
import { taskApi } from "../../backend/client";
import {
  TaskDialog,
  TaskDialogActions,
  TaskMessage,
  TaskTextArea,
  TaskTextInput,
} from "./taskFormUi";

const TransfereeNotesForm = ({ taskId, initialNotes, onClose, onSave }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [notes, setNotes] = useState({
    preferences: initialNotes?.preferences || "",
    pets: initialNotes?.pets || "",
    family: initialNotes?.family || "",
    other: initialNotes?.other || "",
  });

  useEffect(() => {
    const fetchNotes = async () => {
      if (!taskId) return;

      const { data, error } = await taskApi.get(taskId);

      if (error) {
        console.error("Error fetching notes:", error);
        setErrorMessage("Failed to load notes from database");
        return;
      }

      if (data?.transferee_notes) {
        setNotes({
          preferences: data.transferee_notes.preferences || "",
          pets: data.transferee_notes.pets || "",
          family: data.transferee_notes.family || "",
          other: data.transferee_notes.other || "",
        });
      }
    };

    fetchNotes();
  }, [taskId]);

  const handleChange = (field, value) => {
    setNotes((previous) => ({ ...previous, [field]: value }));
  };

  const handleSave = async () => {
    if (!taskId) return;
    setErrorMessage("");
    setSuccessMessage("");

    const { error } = await taskApi.update(taskId, { transferee_notes: notes });

    if (error) {
      setErrorMessage("Failed to save notes.");
      return;
    }

    setSuccessMessage("Transferee notes saved successfully.");
    onSave?.();
    onClose?.();
  };

  return (
    <TaskDialog
      title="Update Transferee Notes"
      description="Profile notes used by the relocation team."
      onClose={onClose}
      className="max-w-xl"
    >
      <div className="space-y-5">
        <TaskMessage>{errorMessage}</TaskMessage>
        <TaskMessage tone="success">{successMessage}</TaskMessage>

        <div className="grid gap-4 sm:grid-cols-2">
          <TaskTextInput
            id="transferee-preferences"
            label="Preferences"
            value={notes.preferences}
            onChange={(event) =>
              handleChange("preferences", event.target.value)
            }
          />
          <TaskTextInput
            id="transferee-pets"
            label="Pets"
            value={notes.pets}
            onChange={(event) => handleChange("pets", event.target.value)}
          />
          <TaskTextInput
            id="transferee-family"
            label="Family"
            value={notes.family}
            onChange={(event) => handleChange("family", event.target.value)}
            className="sm:col-span-2"
          />
          <TaskTextArea
            id="transferee-other"
            label="Other Notes"
            value={notes.other}
            onChange={(event) => handleChange("other", event.target.value)}
            rows={4}
            className="sm:col-span-2"
          />
        </div>

        <TaskDialogActions
          onCancel={onClose}
          onSubmit={handleSave}
          submitLabel="Save Notes"
        />
      </div>
    </TaskDialog>
  );
};

export default TransfereeNotesForm;
